var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLabtestIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_858_421)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.0078 9.4883V49.0075C18.0078 56.1829 23.8247 61.9998 31.0001 61.9998C38.1755 61.9998 43.9924 56.1829 43.9924 49.0075V7.25L18.0078 9.4883Z",
    fill: "url(#paint0_linear_858_421)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.9084 30.4487V48.8637C40.9084 54.332 36.4754 58.7652 31.0069 58.7652C25.5386 58.7652 21.1055 54.3322 21.1055 48.8637V32.6506L40.9084 30.4487Z",
    fill: "url(#paint1_linear_858_421)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6854 37.0726C37.1483 36.4067 41.2715 33.3615 40.8948 30.2709C40.518 27.1803 35.7841 25.2147 30.3212 25.8807C24.8582 26.5466 20.7351 29.5918 21.1118 32.6824C21.4886 35.773 26.2225 37.7385 31.6854 37.0726Z",
    fill: "#B3EEB0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6878 47.0485C28.2132 47.0485 29.4498 45.8119 29.4498 44.2864C29.4498 42.761 28.2132 41.5244 26.6878 41.5244C25.1624 41.5244 23.9258 42.761 23.9258 44.2864C23.9258 45.8119 25.1624 47.0485 26.6878 47.0485Z",
    fill: "url(#paint2_radial_858_421)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.3212 51.6595C36.1113 51.6595 36.7518 51.019 36.7518 50.2289C36.7518 49.4388 36.1113 48.7983 35.3212 48.7983C34.5311 48.7983 33.8906 49.4388 33.8906 50.2289C33.8906 51.019 34.5311 51.6595 35.3212 51.6595Z",
    fill: "url(#paint3_radial_858_421)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.4919 10.6103H45.4921V7.03711L16.5117 9.64547L16.5126 13.2611C16.5574 15.1411 17.7204 16.9305 20.0475 18.274C25.2873 21.2992 34.4396 20.9198 40.4899 17.4266C43.8656 15.4776 45.5616 12.9711 45.4919 10.6103Z",
    fill: "url(#paint4_linear_858_421)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9988 16.5461C39.9836 15.5728 46.0101 11.1217 45.4595 6.60433C44.9088 2.08698 37.9895 -0.786017 30.0046 0.187321C22.0198 1.16066 15.9933 5.61175 16.5439 10.1291C17.0946 14.6465 24.014 17.5195 31.9988 16.5461Z",
    fill: "#E9E5F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.3431 12.606C43.0254 9.90267 43.534 5.81321 39.4789 3.4721C35.4239 1.131 28.3409 1.42453 23.6585 4.12795C18.9762 6.83124 18.4677 10.9207 22.5227 13.2618C26.5777 15.6029 33.6608 15.3094 38.3431 12.606Z",
    fill: "url(#paint5_linear_858_421)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_858_421",
    x1: 18.0078,
    y1: 34.6249,
    x2: 46.5193,
    y2: 34.6249,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D7D1EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898,
    stopColor: "#E9E5F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_858_421",
    x1: 15.7071,
    y1: 44.607,
    x2: 44.4476,
    y2: 44.607,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#60AA5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.217,
    stopColor: "#62AE5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#69BA65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.664,
    stopColor: "#75CF70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#80E37B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_858_421",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26.6878 44.2864) scale(2.76203)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.042,
    stopColor: "#E3F9E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.382,
    stopColor: "#D5F6D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.997,
    stopColor: "#B3EEB0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_858_421",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.3212 50.2289) scale(1.4306 1.4306)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.042,
    stopColor: "#E3F9E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.382,
    stopColor: "#D5F6D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.997,
    stopColor: "#B3EEB0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_858_421",
    x1: 16.5117,
    y1: 7.03711,
    x2: 45.4939,
    y2: 7.03711,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5BAEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507,
    stopColor: "#D7D1EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9E5F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_858_421",
    x1: 19.7852,
    y1: 1.8916,
    x2: 42.2165,
    y2: 1.8916,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5BAEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507,
    stopColor: "#D7D1EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9E5F6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_858_421"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 62,
    height: 62,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLabtestIcon);
export default __webpack_public_path__ + "static/media/labtest_icon.d6c28fa915f4f4a4b30bb69bce0c960c.svg";
export { ForwardRef as ReactComponent };